export const billingPeriod = {
  unit: {
    month: 'mes',
    week: 'semana',
    year: 'año',
    day: 'día',
  },
  singularUnits: {
    month: 'Mensual',
    week: 'Semanal',
    year: 'Anual',
    day: 'Diario',
  },
  plural: 'Cada {{interval}} {{unit}}',
  pluralUnits: {
    month: 'meses',
    week: 'semanas',
    year: 'años',
    day: 'días',
  },
  singularPricePerUnit: '{{ price }} por {{ unit }}',
  pluralPricePerUnit: '{{ price }} cada {{interval}} {{unit}}',
};
